import styled from 'styled-components';
import Mod002 from 'dc/Mod002';
import HeaderComponent from 'challenge/common/KnowledgeComponents/Header/Desktop';
import CategoryImageComponent from 'challenge/common/KnowledgeComponents/CategoryImage';
import StatComponent from 'challenge/common/KnowledgeComponents/Stat';
import DidYouKnowComponent from 'challenge/common/KnowledgeComponents/DidYouKnow';
import StatementComponent from 'challenge/common/KnowledgeComponents/Statement';
import FeedbackFooterComponent from 'challenge/common/KnowledgeComponents/FeedbackFooter';
import InfoPageComponent from 'challenge/common/KnowledgeComponents/InfoPage/Desktop';
import QuizCardComponent from 'challenge/common/KnowledgeComponents/QuizCard';

export const Modal = styled(Mod002)`
  pointer-events: auto;
  padding: 0 24px;
`;

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

export const Header = styled(HeaderComponent)``;

export const InfoPage = styled(InfoPageComponent)``;

export const Stat = styled(StatComponent)`
  margin-bottom: 32px;
`;
export const DidYouKnow = styled(DidYouKnowComponent)`
  margin-bottom: 32px;
`;
export const Statement = styled(StatementComponent)`
  margin-bottom: 32px;
`;
export const CategoryImage = styled(CategoryImageComponent)`
  margin-bottom: 16px;
`;
export const QuizCard = styled(QuizCardComponent)`
  margin-bottom: 32px;
`;

export const Image = styled.img`
  position: relative;
  width: 100%;
  max-width: 288px;
`;

export const FeedbackFooter = styled(FeedbackFooterComponent)``;
